import React from "react";
import { Formik, Form, FieldArray } from "formik";
import { FormikFormGroup, FormikInput, Icon, ModalSubmit } from "components/common";
import { Modal, Row, Col, Button, Alert } from "components/bootstrap";
import useRepositories from "./hooks/useRepositories";
import useRepositoryFormErrors from "./hooks/useRepositoryFormErrors";
const KNOWN_FIELDS = ["name", "uri", "path", "load_defaults"];
const HadoopStorageRepositoryModalForm = ({ hideModal }) => {
  const { onCreateRepository } = useRepositories();
  const { formError, clearFormError, applyBackendErrors } = useRepositoryFormErrors(KNOWN_FIELDS);
  const handleSubmit = (values, { setErrors }) => {
    const conf = Object.fromEntries(
      values.confArray.filter(({ key }) => key).map(({ key, value }) => [key, value])
    );
    const { confArray: _confArray, ...valuesWithoutConfArray } = values;
    const valuesWithConf = { ...valuesWithoutConfArray, conf };
    clearFormError();
    return onCreateRepository({ type: "hdfs", ...valuesWithConf }).then(() => hideModal()).catch((error) => applyBackendErrors(error, setErrors));
  };
  const initialValues = {
    name: "",
    uri: "",
    path: "",
    load_defaults: true,
    conf: {},
    confArray: []
  };
  const validate = (values) => {
    var _a, _b, _c;
    const errors = {};
    if (!((_a = values.name) == null ? void 0 : _a.trim())) errors.name = "Name is required.";
    if (!((_b = values.uri) == null ? void 0 : _b.trim())) errors.uri = "Uri is required.";
    if (!((_c = values.path) == null ? void 0 : _c.trim())) errors.path = "Path is required.";
    return errors;
  };
  return /* @__PURE__ */ React.createElement(
    Formik,
    {
      onSubmit: handleSubmit,
      initialValues,
      validate,
      validateOnMount: true
    },
    ({ isSubmitting, isValidating, isValid, values }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Body, null, formError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, formError), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "text",
        label: "Name",
        name: "name",
        help: "Name of your warm storage repository. Must be unique.",
        required: true
      }
    ), /* @__PURE__ */ React.createElement(FormikFormGroup, { type: "text", label: "Uri", name: "uri", help: "Uri of the nameserver", required: true }), /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "text",
        label: "Path",
        name: "path",
        help: "Path of the warm storage repository",
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        label: "Load defaults",
        name: "load_defaults",
        help: "Whether to load the default Hadoop configuration or not. (Enabled by default)",
        type: "checkbox"
      }
    ))), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("h5", null, /* @__PURE__ */ React.createElement("b", null, "Configuration properties")), /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement("code", null, "conf.", "<", "key", ">"), /* @__PURE__ */ React.createElement("p", null, "Inlined configuration parameter to be added to Hadoop configuration. (Optional) Only client oriented properties from the hadoop core and hdfs configuration files will be recognized by the plugin.")), /* @__PURE__ */ React.createElement(FieldArray, { name: "confArray" }, ({ remove, push }) => /* @__PURE__ */ React.createElement("div", null, values.confArray.length > 0 && values.confArray.map((pair, index) => /* @__PURE__ */ React.createElement(Row, { key: pair.id }, /* @__PURE__ */ React.createElement(Col, { md: 5 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        id: `${pair.key}-key`,
        name: `confArray.${index}.key`,
        placeholder: "Key",
        type: "text"
      }
    )), /* @__PURE__ */ React.createElement(Col, { md: 5 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        id: `${pair.key}-value`,
        name: `confArray.${index}.value`,
        placeholder: "Value",
        type: "text"
      }
    )), /* @__PURE__ */ React.createElement(Col, { md: 1 }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", onClick: () => remove(index) }, /* @__PURE__ */ React.createElement(Icon, { name: "delete" }))))), /* @__PURE__ */ React.createElement(
      Button,
      {
        bsStyle: "primary",
        type: "button",
        onClick: () => push({ id: `newRow-${(/* @__PURE__ */ new Date()).getTime()}`, key: "", value: "" })
      },
      /* @__PURE__ */ React.createElement(Icon, { name: "add" }),
      " Add Conf property"
    )))))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText: "Create",
        submitLoadingText: "Creating...",
        onCancel: hideModal,
        disabledSubmit: isValidating || !isValid,
        isSubmitting
      }
    )))
  );
};
export default HadoopStorageRepositoryModalForm;
